import Header from "../components/Header"

import Styles from "./depression-test-phq-9.module.scss"
export { getServerSideProps } from "../utils/getServerSideProps"
import { useState, useCallback, useMemo } from "react"
import Footer from "../components/local/Footer"

import { useTranslation } from "next-i18next"
import FormInput from "../components/FormInput"

import ProgressSteps from "../components/ProgressSteps"
import Image from "next/image"
import Button from "../components/Button"
import TalkToSolace from "../components/TalkToSolace"

import { isMobile } from "../utils/browser"

function AnxietyTestPage() {
  return (
    <>
      <Header />
      <main className={Styles.Wrapper} id="page-wrap">
        <AnxietyTest />
      </main>
      <Footer />
    </>
  )
}

function AnxietyTest() {
  const { t } = useTranslation("tests", "common")

  const [values, setValues] = useState({})

  const getValue = (key) => values[key] || 0

  const setValue = (key, value) => {
    setValues({ ...values, [key]: value })
  }

  const [step, setStep] = useState(0)

  const stepNames = [
    t("TEST_ANXIETY_PHYSICAL"),
    t("TEST_ANXIETY_COGNITIVE"),
    t("TEST_ANXIETY_EMOTIONAL"),
    t("TEST_ANXIETY_RESULTS"),
  ]

  const testOptions = [
    {
      value: 0,
      label: t("TEST_ANXIETY_NOTHING"),
    },
    {
      value: 1,
      label: t("TEST_ANXIETY_LITTLE"),
    },
    {
      value: 2,
      label: t("TEST_ANXIETY_MODERATED"),
    },
    {
      value: 3,
      label: t("TEST_ANXIETY_LOT"),
    },
  ]

  const handleValueChange = (key) => (e) => {
    setValue(key, e.target.value)
  }

  const scrollUp = () => {
    if (isMobile()) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }, 50)
    }
  }

  const handleBack = () => {
    setStep(step - 1)
    scrollUp()
  }

  const handleMainButton = useCallback(async () => {
    scrollUp()

    setStep(step + 1)
  }, [step])

  const TEST_ANXIETY_PHYSICAL = [
    {
      label: t("TEST_ANXIETY_TIGLING"),
      id: "numbness_tingling",
    },
    {
      label: t("TEST_ANXIETY_FEELING_HOT"),
      id: "feeling_hot",
    },
    {
      label: t("TEST_ANXIETY_WOBBLINESS_LEGS"),
      id: "wobbliness_legs",
    },
    {
      label: t("TEST_ANXIETY_UNABLE_TO_RELAX"),
      id: "unable_to_relax",
    },
    {
      label: t("TEST_ANXIETY_FEAR_WORST_HAPPENING"),
      id: "fear_worst_happening",
    },
    {
      label: t("TEST_ANXIETY_HEART_POUNDING_RACING"),
      id: "heart_pounding_racing",
    },
    {
      label: t("TEST_ANXIETY_SHAKING"),
      id: "shaking",
    },
    {
      label: t("TEST_ANXIETY_DIFFICULTY_BREATHING"),
      id: "difficulty_breathing",
    },
    {
      label: t("TEST_ANXIETY_FEAR_LOSING_CONTROL"),
      id: "fear_losing_control",
    },
    {
      label: t("TEST_ANXIETY_FEAR_DYING"),
      id: "fear_dying",
    },
    {
      label: t("TEST_ANXIETY_NERVOUSNESS_SHAKINESS_INSIDE"),
      id: "nervousness_shakiness_inside",
    },
    {
      label: t("TEST_ANXIETY_FEELING_OF_CHOKING"),
      id: "feeling_of_choking",
    },
    {
      label: t("TEST_ANXIETY_UNSTEADY_LIGHTEADED"),
      id: "unsteady_lightheaded",
    },
    {
      label: t("TEST_ANXIETY_TREMBLING"),
      id: "trembling",
    },
    {
      label: t("TEST_ANXIETY_FEAR_CROWDS"),
      id: "fear_crowds",
    },
    {
      label: t("TEST_ANXIETY_BLUSHING"),
      id: "blushing",
    },
    {
      label: t("TEST_ANXIETY_FEAR_CRITICISM"),
      id: "fear_criticism",
    },
    {
      label: t("TEST_ANXIETY_POUNDING_HEART"),
      id: "pounding_heart",
    },
    {
      label: t("TEST_ANXIETY_FEARFUL_SOMETHING_AWFUL_HAPPEN"),
      id: "fearful_something_awful_happen",
    },
    {
      label: t("TEST_ANXIETY_FEAR_FAINTING"),
      id: "fear_fainting",
    },
    {
      label: t("TEST_ANXIETY_HANDS_TREMBLING"),
      id: "hands_trembling",
    },
  ]

  const TEST_ANXIETY_COGNITIVE = [
    {
      label: t("TEST_ANXIETY_FEAR_WORST_HAPPENING"),
      id: "fear_worst_happening",
    },
    {
      label: t("TEST_ANXIETY_FEAR_LOSING_CONTROL"),
      id: "fear_losing_control",
    },
    {
      label: t("TEST_ANXIETY_FEAR_DYING"),
      id: "fear_dying",
    },
    {
      label: t("TEST_ANXIETY_FEARFUL_SOMETHING_AWFUL_HAPPEN"),
      id: "fearful_something_awful_happen",
    },
    {
      label: t("TEST_ANXIETY_FEAR_CROWDS"),
      id: "fear_crowds",
    },
    {
      label: t("TEST_ANXIETY_FEAR_CRITICISM"),
      id: "fear_criticism",
    },
  ]

  const TEST_ANXIETY_EMOTIONAL = [
    {
      label: t("TEST_ANXIETY_NERVOUSNESS_SHAKINESS_INSIDE"),
      id: "nervousness_shakiness_inside",
    },
    {
      label: t("TEST_ANXIETY_BLUSHING"),
      id: "blushing",
    },
  ]

  const QUESTIONS = [
    TEST_ANXIETY_PHYSICAL,
    TEST_ANXIETY_COGNITIVE,
    TEST_ANXIETY_EMOTIONAL,
  ]

  const stepFields = (step) => (
    <>
      {step < 3 ? (
        QUESTIONS[step].map(({ label, id }) => (
          <FormInput
            key={id}
            label={label}
            type="select-boxes"
            options={testOptions}
            value={getValue(id)}
            onChange={handleValueChange(id)}
          />
        ))
      ) : (
        <TestResult values={values} />
      )}
    </>
  )

  const mainButtonLabel = useMemo(() => {
    const labelNext = (
      <div className="flex items-center">
        {t("HOME_NEXT", { ns: "common" })}
        <Image
          width={24}
          height={24}
          className="ml-2"
          src="/assets/icon-arrow-right-white.svg"
          alt="arrow-right"
        />
      </div>
    )

    const stepLabels = [labelNext, labelNext, t("TEST_SEE_YOUR_RESULTS")]

    return stepLabels[step]
  }, [t, step])

  return (
    <>
      <ProgressSteps step={step} stepNames={stepNames} />
      {stepFields(step)}
      <div className="flex justify-between w-full h-20 relative">
        {[1, 2, 3].includes(step) && (
          <Button onClick={handleBack} style="secondary">
            <div className="flex items-center">
              <Image
                width={24}
                height={24}
                className="mr-2"
                src="/assets/icon-arrow-left-black.svg"
                alt="arrow-right"
              />

              {t("HOME_BACK", { ns: "common" })}
            </div>
          </Button>
        )}

        {step !== 3 ? (
          <Button
            onClick={handleMainButton}
            style="primary"
            className="right-0 absolute text-lg sm:text-2xl"
          >
            {mainButtonLabel}
          </Button>
        ) : (
          <TalkToSolace />
        )}
      </div>
    </>
  )
}

const importantKeys = []

const calcScore = (values) =>
  Object.entries(values).reduce(
    (acc, [key, value]) =>
      acc + (importantKeys.includes(key) ? 2 * value : value),
    0
  )

function TestResult({ values }) {
  const score = calcScore(values)
  const { t } = useTranslation("tests")

  const getResults = (score) => {
    const totalQuestions = 21

    const scorePercentage = (score / (totalQuestions * 3)) * 100

    if (scorePercentage <= 10) {
      return {
        title: t("TEST_ANXIETY_VERY_LOW"),
        description: t("TEST_ANXIETY_VERY_LOW_DESCRIPTION"),
      }
    }

    if (scorePercentage <= 25) {
      return {
        title: t("TEST_ANXIETY_LOW"),
        description: t("TEST_ANXIETY_LOW_DESCRIPTION"),
      }
    }

    if (scorePercentage <= 50) {
      return {
        title: t("TEST_ANXIETY_MODERATE"),
        description: t("TEST_ANXIETY_MODERATE_DESCRIPTION"),
      }
    }

    if (scorePercentage <= 75) {
      return {
        title: t("TEST_ANXIETY_HIGH"),
        description: t("TEST_ANXIETY_HIGH_DESCRIPTION"),
      }
    }

    return {
      title: t("TEST_ANXIETY_VERY_HIGH"),
      description: t("TEST_ANXIETY_VERY_HIGH_DESCRIPTION"),
    }
  }

  const { title, description } = getResults(score)

  return (
    <>
      <h2>{title}</h2>
      <h3>{description}</h3>
    </>
  )
}

export default AnxietyTestPage
